import useCurrentUser from "@casino/legacy/client/hooks/user/useCurrentUser";
import PageTitle from "@casino/legacy/client/shared/PageTitle";
import Stack from "@casino/legacy/client/shared/Stack";
import type { TournamentsListState } from "../../hooks/useTournaments/TournamentsSectionState";
import TournamentSection from "../../shared/TournamentSection";

type Props = {
  /** Server-rendered first page of each status section. */
  initial?: TournamentsListState;
};

const Tournaments: FC<Props> = ({ initial }) => {
  const { user } = useCurrentUser();
  return (
    <Stack maxWidth="73.25" space="medium" margin="0 auto">
      <PageTitle translateId="game-leaderboard.tournaments" />
      <Stack space="2.75rem">
        <TournamentSection
          status="current"
          dataTestId="current-tournaments"
          initial={initial?.current}
        />
        <TournamentSection
          status="future"
          dataTestId="future-tournaments"
          initial={initial?.future}
        />
        {user?.id && <TournamentSection onlyMine />}
        {!user?.id && (
          <TournamentSection
            status="past"
            dataTestId="past-tournaments"
            initial={initial?.past}
          />
        )}
      </Stack>
    </Stack>
  );
};

export default Tournaments;
